import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruckMoving, faPlane, faShip } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const ShipmentCountCard = () => {
  const [shipmentCount, setShipmentCount] = useState(0);
  const [transSegmentation, setTransSegmentation] = useState({});
  const { fetchData } = useContext(DataContext);

  useEffect(() => {
    const fetchShipments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/ff_shipment`);
        setShipmentCount(response.data.length);
        
        const segmentation = response.data.reduce((acc, shipment) => {
          acc[shipment.trans] = (acc[shipment.trans] || 0) + 1;
          return acc;
        }, {});
        setTransSegmentation(segmentation);
      } catch (error) {
        console.error('Error fetching shipments:', error);
      }
    };

    fetchShipments();
  }, [fetchData]);

  // Function to return the appropriate icon based on the trans value
  const getTransIcon = (trans) => {
    switch(trans) {
      case 'AIR': return faPlane;
      case 'ROAD': return faTruckMoving;
      case 'SEA': return faShip;
      default: return faTruckMoving; // Default icon if trans does not match
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faTruckMoving} className="text-blue-600 mr-3" />
          Shipment Count
        </h2>
        <a href="/shipments" className="text-md text-blue-600 hover:text-blue-800 transition duration-300">
          View all
        </a>
      </div>
      <div className="text-center mb-4">
        <FontAwesomeIcon icon={faTruckMoving} className="text-blue-600 text-3xl mb-2" />
        <p className="text-md text-gray-600">Total Shipments</p>
        <p className="text-2xl font-semibold text-gray-800">{shipmentCount}</p>
      </div>
      {/* Horizontal Segmentation Display with Icons */}
      <div className="flex flex-wrap justify-center items-center mt-4">
        {Object.entries(transSegmentation).map(([key, value]) => (
          <div key={key} className="flex items-center m-2">
            <FontAwesomeIcon icon={getTransIcon(key)} className="text-blue-600 mr-2" />
            <span className="text-md text-gray-600 mr-2">{key}:</span>
            <span className="font-semibold text-gray-800">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentCountCard;
